import { render, staticRenderFns } from "./AwardBanner.vue?vue&type=template&id=183ea0bb&scoped=true"
import script from "./AwardBanner.vue?vue&type=script&lang=js"
export * from "./AwardBanner.vue?vue&type=script&lang=js"
import style0 from "./AwardBanner.vue?vue&type=style&index=0&id=183ea0bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183ea0bb",
  null
  
)

export default component.exports